// src/components/ScatterChartConfig.js

// Converts your raw data into the format expected by the scatter chart
export const ScatterChartData = (data) => {
  const transformedData = data.map(({ value, value2 }) => ({
    x: value,
    y: value2
  }));
  return { 
    datasets: [
      {
        label: 'Scatter Plot Example',
        data: transformedData,
        backgroundColor: 'blue'
      }
    ]
  };
};

// Generates options for the scatter chart
export const ScatterChartOptions = (xUnit = '', yUnit = '', xLabel = 'X-Axis Label', yLabel = 'Y-Axis Label') => ({
  scales: {
    x: {
      type: 'linear',
      position: 'bottom',
      title: {
        display: true,
        text: xLabel + (xUnit ? ` (${xUnit})` : '')
      }
    },
    y: {
      title: {
        display: true,
        text: yLabel + (yUnit ? ` (${yUnit})` : '')
      }
    }
  },
  plugins: {
    legend: {
      display: true,
      position: 'top'
    },
    tooltip: {
      callbacks: {
        label: (context) => {
          const { x, y } = context.parsed;
          return `(${x} ${xUnit}, ${y} ${yUnit})`;
        }
      }
    }
  }
});
